(ns ncr.widgets.bulk-selection
  (:require [clojure.set :as set]
            [goog.events :as gevents]
            [goog.events.EventType :as EventType]
            [ncr.etc.pf :as pf]
            [ncr.etc.util :as u]
            [uix.core.alpha :as uix]))

(defn- calculate-selected [selected total]
  (let [selected-all? (= (count selected) total)
        selected-any? (boolean (seq selected))]
    {:selected-all? selected-all?
     :selected-any? selected-any?
     :checked? (when (or selected-all? (not selected-any?)) selected-all?)}))

; see https://www.patternfly.org/patterns/bulk-selection/#bulk-selection
(defn c-dropdown [{:keys [label-fn selected all on-change]}]
  (let [*dd-node-ref (uix/ref nil)
        *open? (uix/state false)
        open? @*open?
        total (count all)

        {:keys [selected-any? checked?]}
        (uix/memo (fn [] (calculate-selected selected total)) [selected total])]

    (uix/with-effect [open?]
      (when open?
        (let
          [listener-id
           (gevents/listen js/document.body EventType/CLICK
             (fn [e]
               (when-some [dd-node @*dd-node-ref]
                 (when (and open? (not (.contains dd-node (.-target e))))
                   (reset! *open? false)))))]
          #(gevents/unlistenByKey listener-id))))

    [pf/c-dropdown
     {:is-open open?
      :on-select #(reset! *open? false)
      :dropdown-items
      [[pf/c-dropdown-item {:key :none :on-click #(on-change false)} "Select none"]
       [pf/c-dropdown-item {:key :all :on-click #(on-change true)} (u/format "Select all %s" total)]]

      :toggle
      [pf/c-dropdown-toggle
       {:on-toggle (fn [_ e]
                     (reset! *dd-node-ref (-> e .-currentTarget (.closest ".pf-c-dropdown")))
                     (swap! *open? not))
        :split-button-items
        [(uix/as-element
           (pf/c-dropdown-toggle-checkbox
             {:id :quick-select-ll
              :key :quick-select-ll
              :is-checked checked?
              :on-change #(on-change (not (boolean checked?)))}
             (when selected-any? (label-fn (count selected)))))]}]}]))

(defn c-fragment-attachments-list [{:keys [fragment selected on-change]}]
  (let [{:keys [id name attachments]} fragment
        attachment-ids (uix/memo (fn [] (into #{} (map :id attachments))) [attachments])
        selected (uix/memo (fn [] (set/intersection attachment-ids selected)) [attachment-ids selected])
        {:keys [selected-all? checked?]}
        (uix/memo (fn [] (calculate-selected selected (count attachment-ids))) [selected attachment-ids])]
    [pf/c-data-list-item {:key id}
     [pf/c-data-list-item-row
      {:class :ncr-c-bulk-selection__fragment-attachments--fragment-title}
      [:div.pf-c-data-list__checkbox
       {:on-click #(on-change attachment-ids (not selected-all?))}
       [pf/c-dropdown-toggle-checkbox
        {:id (str "fr_" id)
         :is-checked checked?}]]
      [pf/c-data-list-item-cells {}
       [pf/c-data-list-cell name]]]
     (for [{:keys [fileName id]} attachments :let [selected? (contains? selected id)]]
       [pf/c-data-list-item-row {:key id}
        [pf/c-data-list-checkbox
         {:id (str "cb_" id)
          :is-checked selected?
          :on-change #(on-change #{id} (not selected?))}]
        [pf/c-data-list-item-cells {}
         [pf/c-data-list-cell fileName]]])]))
